import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  quote: string;
}
export function TestimonialCard({
  name,
  location,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-58">
      <div className="flex gap-1 mb-4" data-id="element-59">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-60" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-61">"{quote}"</p>
      <div className="mt-auto flex items-center gap-3" data-id="element-62">
        <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center font-bold text-gray-500" data-id="element-63">
          {name.charAt(0)}
        </div>
        <div data-id="element-64">
          <p className="font-bold text-gray-900 text-sm" data-id="element-65">{name}</p>
          <p className="text-gray-500 text-xs" data-id="element-66">{location}</p>
        </div>
      </div>
    </div>;
}